/**
 * State used in rendering TableBody
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
